const menuList = {
    state: {
        menuList: [], //所有菜单
    },
    getters: {
        menuList: state => state.menuList,
    },
    mutations: {
        SET_MENU_LIST: (state, data) => {
            state.menuList = data;
        },
        SET_BUTTON_AUTH: (state, data) => {
            state.buttonAuth = data;
        }
    },
    actions: {
        // 获取菜单 
        getMenuList: ({
            commit
        }) => {

            let routes = [{
                    path: "/",
                    meta: {
                        title: "首页",
                        icon: "home"
                    }
                },
                {
                    path: "/homePageConfiguration",
                    meta: {
                        title: "首页轮播图",
                        icon: "homePageConfiguration"
                    }
                },
                {
                    path: "/postManagement",
                    meta: {
                        title: "文章管理",
                        icon: "postManagement"
                    }
                },
                {
                    path: "/jobInfo",
                    meta: {
                        title: "职位信息",
                        icon: "jobInfo"
                    }
                },
                {
                    path: "/jobTypeInfo",
                    meta: {
                        title: "职位类别",
                        icon: "jobTypeInfo"
                    }
                },
                {
                    path: "/applyJob",
                    meta: {
                        title: "申请职位",
                        icon: "applyJob"
                    }
                }
            ]
            localStorage.setItem("router", JSON.stringify(routes));
            commit("SET_MENU_LIST", routes)
        }

    }
};

export default menuList